export default __webpack_public_path__ + "static/media/gallery-img06.ad6af5b4.jpg";